/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Security_GuardrailsInputs */

const en_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security Guardrails`)
};

const es_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medidas de seguridad`)
};

const fr_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrières de sécurité`)
};

const de_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheitsvorkehrungen`)
};

const ja_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティガードレール`)
};

const zh_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全护栏`)
};

const ar_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حواجز الأمان`)
};

const id_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar Keamanan`)
};

const it_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misure di Sicurezza`)
};

const ru_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меры безопасности`)
};

const pt_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barreiras de Segurança`)
};

const ko_security_guardrails = /** @type {(inputs: Security_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안 가이드레일`)
};

/**
* | output |
* | --- |
* | "Security Guardrails" |
*
* @param {Security_GuardrailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const security_guardrails = /** @type {((inputs?: Security_GuardrailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Security_GuardrailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_security_guardrails(inputs)
	if (locale === "es") return es_security_guardrails(inputs)
	if (locale === "fr") return fr_security_guardrails(inputs)
	if (locale === "de") return de_security_guardrails(inputs)
	if (locale === "ja") return ja_security_guardrails(inputs)
	if (locale === "zh") return zh_security_guardrails(inputs)
	if (locale === "ar") return ar_security_guardrails(inputs)
	if (locale === "id") return id_security_guardrails(inputs)
	if (locale === "it") return it_security_guardrails(inputs)
	if (locale === "ru") return ru_security_guardrails(inputs)
	if (locale === "pt") return pt_security_guardrails(inputs)
	return ko_security_guardrails(inputs)
});